<script lang="ts" setup>
</script>

<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 3.94755V8.05245H2.66667L6 11.4732V0.526796L2.66667 3.94755H0ZM9 6C9 4.78905 8.32 3.74914 7.33333 3.24287V8.75029C8.32 8.25086 9 7.21095 9 6ZM7.33333 0V1.40935C9.26 1.99772 10.6667 3.83124 10.6667 6C10.6667 8.16876 9.26 10.0023 7.33333 10.5906V12C10.0067 11.3774 12 8.92816 12 6C12 3.07184 10.0067 0.622577 7.33333 0Z"
      fill="#FAFAFB"
    />
  </svg>
</template>

<style lang="scss" scoped>
</style>
